import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { processActions } from "../../reducer/processReducer";
import logoSplash from "../../images/logo_splash.png";

class EmailConfirm extends Component {
  state = {
    email: "",
    isNew: null,
  };

  // eslint-disable-next-line consistent-return
  componentDidMount() {
    document.title = "Потвърждение - A1 Xplore TV GO";

    const { history, process, resetEmail } = this.props;

    if (!(process.email && process.token && process.token.isOk === true)) {
      history.push("/start");
      return false;
    }

    this.setState({ email: process.email });
    this.setState({ isNew: process.isNew });

    resetEmail();
  }

  render() {
    const { history } = this.props;
    const { email, isNew } = this.state;

    const textInfo =
      isNew === true ? (
        <p>
          Моля, кликни върху бутон &quot;Потвърдете e-mail адреса си&quot; в него, за да продължиш с регистрацията. В
          противен случай акаунтът ти не може да бъде активиран.
        </p>
      ) : (
        <p>
          Моля, кликни върху бутон &quot;Потвърдете e-mail адреса си&quot; в него, за да продължиш да гледаш телевизия
          през обновеното ни приложение A1 Xplore TV GO.
        </p>
      );

    return (
      <div className="page page-confirm">
        <div className="header-bg" />

        <div className="container container--small">
          <div className="container-head">
            <img src={logoSplash} alt="" />
            <button type="button" className="tag-btn--back" onClick={history.goBack}>
              <i className="a1now-icon-arrow_left" /> НАЗАД
            </button>
          </div>
          <div className="container-body">
            <h1 className="tag-title">Потвърждение</h1>

            <div className="tag-content">
              <p>Изпратихме ти e-mail на</p>
              <h3 className="tag-color-red no-break-out">{email}</h3>
              {textInfo}
            </div>

            <div className="tag-content tag-content__help" style={{ marginTop: "40px" }}>
              Не получи ли e-mail?{" "}
              <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
                Помощ
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetEmail: () => dispatch(processActions.resetEmail()),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(EmailConfirm);
